import { GlobalStyles } from '@mui/material'
import { ConfigContext } from 'contexts/ConfigContext'
import React, { useContext } from 'react'

const TableOverrideStyle = ({ fieldKey, uischema }) => {
  const configContext = useContext(ConfigContext)
  const { layoutType } = configContext.state
  let colorText = layoutType === 'dark' ? '#adb7be' : '#495057' + ' !important'

  return (
    <GlobalStyles
      styles={{
        [`#${fieldKey} .MuiMenu-paper`]: {
          backgroundColor: 'white',
        },
        [`#${fieldKey} .MuiMenu-root`]: {
          backgroundColor: 'transparent',
          maxWidth: uischema.maxWidth || '100%',
          '& [class*="Component-horizontalScrollContainer-"]': {
            backgroundColor: 'transparent',
            color: colorText,
            display: 'inline-grid',
            width: '100%',
            maxHeight: uischema.maxHeight || '100%',
            overflowY: 'auto',
          },
        },
        [`#${fieldKey} .MuiTableHead-root`]: {
          '& [class*="MuiTableRow-"]': {
            backgroundColor: uischema.headerColor + ' !important',
          },
          '& [class*=" MuiTableCell-head"]': {
            color: uischema.headerTextColor + ' !important',
            fontWeight: uischema.headerBold ? 'bold' : 'normal' + ' !important',
          },
        },
        [`#${fieldKey} .MuiTableRow-root`]: {
          '&:nth-of-type(odd)': {
            backgroundColor: uischema.rowColor1 || 'transparent',
            color: uischema.rowTextColor1 || colorText,
            '& [class*="MuiTableCell-body-"]': {
              color: uischema.rowTextColor1 || colorText,
            },
          },
          '&:nth-of-type(even)': {
            backgroundColor: uischema.rowColor2 || 'transparent',
            color: uischema.rowTextColor2 || colorText,
            '& [class*="MuiTableCell-body-"]': {
              color: uischema.rowTextColor2 || colorText,
            },
          },
          '& [class*="ForwardRef(MTableHeaderRef)-header-"]': {
            backgroundColor: 'transparent',
            color: colorText,
          },
        },
      }}
    />
  )
}

export default TableOverrideStyle
